import { Box } from "@mui/material";
import React from "react";

export default function SpaceBG(): JSX.Element {

  return (
    <Box sx={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: -1,
      // backgroundImage: "url(/img/stars.png)",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    }}>


    </Box>
  );

}